import type { OmuiCountBadgeComponent } from '../../../CountBadge'

export const OmuiCountBadge: OmuiCountBadgeComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: 14,
      minWidth: 14,
      width: 'fit-content',
      borderRadius: 7,
      fontSize: 8,
      color: theme.palette.neutralLight[0],
      paddingInline: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
  },
  variants: [
    {
      props: { color: 'neutral' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.neutralLight[900],
      }),
    },
    {
      props: { color: 'secondary' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.secondary.main,
      }),
    },
    {
      props: { color: 'success' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.success.main,
      }),
    },
    {
      props: { color: 'error' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.error.main,
      }),
    },
  ],
}
